<template>
	<div class="QuestionBankList">
		<div class="list">
			<div>
				<el-input clearable placeholder="请搜索标签/名称/题库" v-model="inputName" class="input-with-select">
					<el-button @click="getBankOptions(0)" slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div class="header-box">
				<div class="myBank-box">
					<span class="myBank-title">自建题库</span>
					<span title="刷新" @click="getBankApi(0)" class="el-icon-refresh-right icon"></span>
				</div>

				<div>
					<el-button type="text" @click="addVisible = true">新建题库</el-button>
					<!-- <el-button type="text" @click="toManageBank">管理</el-button> -->
					<el-button type="text" @click="reference">引用</el-button>
				</div>
			</div>
			<el-menu class="el-menu-vertical-demo" @open="myOptionsOpen">
				<template v-if="myOptions.length > 0">
					<el-submenu class="Level2" v-for="(item, index) in myOptions" :key="item.id" :index="`${item.value}-${index}`">
						<template slot="title">
							<span>{{ item.label }}</span>
						</template>
						<el-menu-item v-for="info in item.questionsList" :key="info.id" @click="addQuestion(info)" class="ellipsis1">
							<span v-if="info.quesLabelName">[ {{ modificationLabelName(info.quesLabelName) }} ]</span>
							{{ $functions.htmlFormat(info.questionsName) }}
						</el-menu-item>
					</el-submenu>
				</template>
				<div v-else class="null">暂无内容</div>
			</el-menu>
		</div>
		<div class="list">
			<div class="header-box"><span>系统题库</span></div>
			<el-menu class="el-menu-vertical-demo" @open="systemOptionsOpen">
				<template v-if="systemOptions.length > 0">
					<el-submenu class="Level2" v-for="(item, index) in systemOptions" :key="item.id" :index="`1-${item.value}-${index}`">
						<template slot="title">
							<span>{{ item.label }}</span>
						</template>
						<el-menu-item v-for="(info, i) in item.questionsList" :key="info.id" :index="`1-${index + 1}-${i + 1}`" @click="addQuestion(info)">
							<span v-if="info.quesLabelName">[ {{ modificationLabelName(info.quesLabelName) }} ]</span>
							{{ $functions.htmlFormat(info.questionsName) }}
						</el-menu-item>
					</el-submenu>
				</template>
				<div v-else class="null">暂无内容</div>
			</el-menu>
		</div>
		<el-dialog :close-on-click-modal="false" :append-to-body="true" title="新建题库" :visible.sync="addVisible" width="30%">
			<el-form size="small" label-position="top" :model="form" ref="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="题库名称" prop="bankName" :rules="[{ required: true, message: '题库名称不能为空' }]">
					<el-input maxlength="15" show-word-limit v-model="form.bankName"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancelaAddBank('form')">取 消</el-button>
				<el-button size="small" type="primary" @click="addBank('form')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog class="manage-bank-dialog" :append-to-body="true" title="自建题库" :visible.sync="manageVisible" width="50%" :before-close="handleClose" :close-on-click-modal="false">
			<div class="manage-bank" style="height: 400px; display: flex;">
				<div class="left scroll-body" style="height: 100%; width: 30%; border-right: 1px solid #ccc;border-top: 1px solid #ccc;overflow-y: scroll;">
					<template v-if="manageBankList.length > 0">
						<div
							v-for="item in manageBankList"
							:key="item.id"
							style="
                                cursor: pointer;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding: 0 15px;"
							@click="toGetQuestion(item.id)"
						>
							<div style="width: 100%;padding: 5px 0;">
								<p
									v-if="!item.isRename"
									:title="item.name"
									style="
                                        width: 80%;
                                        display: -webkit-box;
                                        overflow: hidden;   
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 1;"
								>
									{{ item.name }}
								</p>
								<el-input v-else size="mini" style="margin-right: 10px;" @blur="confirmRenameBlur(item)" v-model="item.name" placeholder="请输入内容"></el-input>
							</div>
							<el-dropdown @command="editBank($event, item)">
								<i class="el-icon-more" style="color: #ccc;font-size: 16px;"></i>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="a">重命名</el-dropdown-item>
									<el-dropdown-item command="b">删除</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</template>

					<div v-else class="null">暂无内容</div>
				</div>
				<div class="right scroll-body" style="height: 100%; width: 70%;border-top: 1px solid #ccc;overflow-y: scroll;">
					<ExamQuesTemplate
						v-if="paper.questionsList.length > 0 && bankType == 0"
						ref="examQuesTemplate"
						:paper="paper"
						:isBankViewTest="true"
						@toGetQuestion="toGetQuestion"
					></ExamQuesTemplate>
					<QuestionnaireQuesTemplate
						v-if="paper.questionsList.length > 0 && bankType == 1"
						:paper="paper"
						:isBankViewTest="true"
						@toGetQuestion="toGetQuestion"
					></QuestionnaireQuesTemplate>
					<div v-if="(paper.questionsList.length == 0 && bankType == 0) || (paper.questionsList.length == 0 && bankType == 1)" class="null">暂无内容</div>
				</div>
			</div>
		</el-dialog>
		<referenceDialog ref="referenceDialog" :bankType="bankType" @quesFormBand="addQuestion"></referenceDialog>
	</div>
</template>

<script>
import ExamQuesTemplate from '@/components/examQuesTemplate/index.vue';
import QuestionnaireQuesTemplate from '@/page/myQuestionnaire/components/testPaperDesign/index';
import referenceDialog from '@/components/examQuesTemplate/referenceDialog.vue';
import Paper from '@/page/myQuestionnaire/js/Paper.js';
export default {
	name: 'QuestionBankList',
	components: {
		QuestionnaireQuesTemplate,
		ExamQuesTemplate,
		referenceDialog
	},
	props: {
		typeObj: {
			type: Object,
			default: () => {
				return {};
			}
		},
		collapseVisible: {
			type: Array,
			default: () => {
				return [];
			}
		},
		bankType: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			inputName: '',
			myOptions: [],
			systemOptions: [],
			form: {
				bankName: ''
			},
			addVisible: false,
			paper: {
				questionsList: []
			},
			manageVisible: false,
			manageBankList: [],
			bankQuestionsList: [],
			actionBid: ''
		};
	},
	created() {
		this.getBankOptions();
	},
	methods: {
		reference() {
			this.$refs.referenceDialog.loadData();
		},
		modificationLabelName(name) {
			// console.log('name', name);
			let newLabelName = name.toString();
			console.log('newLabelName', newLabelName);
			return newLabelName;
		},
		handleClose() {
			this.getBankApi(0);
			this.manageVisible = false;
		},
		// 确认重命名
		confirmRenameBlur(item) {
			this.UpdateBank(item);
		},
		// 重命名接口
		UpdateBank(item) {
			let data = {
				name: item.name,
				id: item.id,
				isSystemBank: 0, // 是否系统题库
				bankType: this.bankType // 0考试 1问卷
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankUpdate}`,
				method: 'POST',
				data: data,
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						item.isRename = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editBank(e, item) {
			console.log(item.id);
			if (e == 'a') {
				// 重命名
				item.isRename = true;
			} else {
				// 删除
				this.$confirm('删除后将删除分组内所有题目', '删除确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
					.then(() => {
						let arr = [item.id];
						arr.push(item.id);
						this.saveMyDelApi(arr);
					})
					.catch(() => {});
			}
		},
		// 删除题库
		saveMyDelApi(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankDel}?ids=${ids}`,
				method: 'GET',
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						that.getBankApi(0);
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.paper.questionsList.forEach((info, index) => {
							if (index == 0 && ids.indexOf(info.bqid) != -1) {
								that.paper.questionsList = [];
							}
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		toManageBank() {
			this.manageVisible = true;
			this.getBankApi(0);
		},
		cancelaAddBank(formName) {
			this.$refs[formName].resetFields();
			this.addVisible = false;
		},
		addBank(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let data = {
						isSystemBank: 0, // 我的题库
						name: this.form.bankName,
						type: '未分类',
						bankType: this.bankType // 0考试 1问卷
					};
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.examBankSave}`,
						method: 'POST',
						data: data,
						cb(res) {
							// console.log(res);
							if (res.code == '0') {
								that.setPaperJson(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		setPaperJson(id) {
			let paper = new Paper();
			let that = this;
			let data = {
				id: id,
				paperjson: JSON.stringify(paper),
				bankType: this.bankType
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddQuess}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						that.getBankApi(0);
						that.cancelaAddBank('form');
						that.$message({
							message: '添加成功',
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		myOptionsOpen(e) {
			console.log('我的题库0',e)
			let arr = e.split('-');
			let obj = {
				arr: this.myOptions,
				bid: arr[0],
				i: arr[1]
			};
			this.getQuestion(obj);
		},
		systemOptionsOpen(e) {
			console.log('系统题库0',e)
			let arr = e.split('-');
			let obj = {
				arr: this.systemOptions,
				bid: arr[1],
				i: arr[2]
			};
			this.getQuestion(obj);
		},
		toGetQuestion(bid) {
			if (bid) this.actionBid = bid;
			this.getQuestion({ bid: this.actionBid });
		},
		getQuestion(obj) {
			if (obj.arr) {
				if (!obj.arr.questionsList) {
					this.$set(obj.arr[obj.i], 'questionsList', []);
				} else {
					obj.arr.questionsList = [];
				}
			}
			let that = this;
			let data = this.$qs.stringify({
				bankId: obj.bid, // 0自建题库 1系统题库
				difficulty: '',
				pageIndex: 1,
				pageSize: 10000,
				type: '', // 题库类别
				isDel: 0, // 是否为回收站列表
				bankType: this.bankType, // 是否为0考试 1问卷
				name: this.inputName
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankQuesList}?${data}`,
				method: 'GET',
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						let list = [];
						res.resultBody.datas.forEach((info, index) => {
							let quesJson = JSON.parse(info.quesJson);
							quesJson.bqid = info.id;
							quesJson.quesLabelName = quesJson.quesLabelName;
							list.push(quesJson);
						});
						// console.log(that.paper.questionsList);
						if (obj.arr) {
							obj.arr[obj.i].questionsList = [...list];
						} else {
							that.paper.questionsList = [...list];
							// console.log(that.paper.questionsList);
						}
					}
				}
			};
			this.$util.request(params);
		},
		addQuestion(e) {
			this.$emit('quesFormBand', e);
		},
		getBankOptions() {
			this.getBankApi(0);
			this.getBankApi(1);
		},
		getBankApi(isSystem) {
			let that = this;
			let data = this.$qs.stringify({
				isSystem: isSystem, // 0自建题库 1系统题库
				pageIndex: 1,
				pageSize: 10000,
				bankType: this.bankType, // 0考试题库 1问卷题库
				name: this.inputName
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					// console.log(res);
					if (res.code == '0') {
						if (isSystem == 0) {
							that.myOptions = [];
							res.resultBody.datas.forEach((info, index) => {
								if (index == 0) {
									that.actionBid = info.id;
									that.getQuestion({ bid: info.id });
								}
								that.myOptions.push({
									label: info.name,
									value: info.id
								});
								that.$set(info, 'isRename', false);
								// console.log(that.myOptions)
							});
							that.manageBankList = [...res.resultBody.datas];
						} else {
							that.systemOptions = [];
							res.resultBody.datas.forEach((info, index) => {
								if (index == 0) {
									that.actionBid = info.id;
									that.getQuestion({ bid: info.id });
								}
								that.systemOptions.push({
									label: info.name,
									value: info.id
								});
							});
						}
					} else {
						if (isSystem == 0) {
							that.myOptions = [];
							that.manageBankList = [];
						} else {
							that.systemOptions = [];
						}
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.null {
	text-align: center;
	font-size: 12px;
	height: 150px;
	line-height: 150px;
	color: #ccc;
}
.QuestionBankList {
	height: 100%;
	width: 100%;
	.header-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		height: 40px;
		border-bottom: solid 1px #e6e6e6;
		.myBank-box {
			.icon {
				font-size: 12px;
				color: #a7a6a6;
				margin-left: 10px;
				cursor: pointer;
			}
		}
	}
	.list + .list {
		margin-top: 15px;
		border-top: solid 1px #e6e6e6;
	}
	.el-menu-vertical-demo {
		/deep/.el-submenu__title {
			height: 26px;
			line-height: 26px;
			word-break: keep-all;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		/deep/.el-submenu .el-menu-item {
			height: auto;
			line-height: 26px;
			padding: 0px 20px;
		}
		/deep/.el-menu {
			border-right: 0px;
			// border-top: solid 1px #e6e6e6;
			// border-bottom: solid 1px #e6e6e6;
			// padding: 10px 0;
			// margin-bottom: 15px;
			.el-menu-item.is-active {
				color: #000;
			}
		}
	}

	.el-submenu__title span {
		display: inline-block;
		width: 80%;
	}
	.el-menu-item {
		width: 100%;
	}
	.el-submenu__title span,
	.el-menu-item {
		/* 下拉框文字 超出隐藏 */
		// white-space: nowrap;
		// -webkit-box-flex: 1;
		// overflow: hidden;
		// text-overflow: ellipsis;
		display: -webkit-box;
		word-break: break-all;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: pre-line;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3; //超出几行隐藏我就用几行
	}
}
</style>
<style lang="scss">
.item_container {
	margin: 10px !important;
	border: 1px solid #eaeaea;
	border-radius: 5px;
}
</style>
